/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Mediaslider_Nextslide2Inputs */

const id_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slide berikutnya`)
};

const ms_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slaid seterusnya`)
};

const da_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Næste slide`)
};

const de_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächste Folie`)
};

const en_us2_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next slide`)
};

const es_es2_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diapositiva siguiente`)
};

const es_mx2_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diapositiva siguiente`)
};

const fil_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Susunod na slide`)
};

const fr_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diapositive suivante`)
};

const it_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slide successiva`)
};

const hu_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Következő dia`)
};

const nl_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volgende dia`)
};

const no_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neste lysbilde`)
};

const pl_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Następny slajd`)
};

const pt_br2_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next slide`)
};

const pt_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slide seguinte`)
};

const ro_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slide următor`)
};

const fi_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuraava dia`)
};

const sv_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nästa bild`)
};

const vi_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang trình chiếu tiếp`)
};

const tr_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonraki slayt`)
};

const cs_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Další snímek`)
};

const bg_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следващ слайд`)
};

const ru_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следующий слайд`)
};

const uk_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наступний слайд`)
};

const ar_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الشريحة التالية`)
};

const hi_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगली स्लाइड`)
};

const th_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สไลด์ถัดไป`)
};

const ja_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のスライド`)
};

const zh_cn2_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next slide`)
};

const zh_hant1_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next slide`)
};

const ko_components_mediaslider_nextslide2 = /** @type {(inputs: Components_Mediaslider_Nextslide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next slide`)
};

/**
* | output |
* | --- |
* | "Next slide" |
*
* @param {Components_Mediaslider_Nextslide2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_mediaslider_nextslide2 = /** @type {((inputs?: Components_Mediaslider_Nextslide2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Mediaslider_Nextslide2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_mediaslider_nextslide2(inputs)
	if (locale === "ms") return ms_components_mediaslider_nextslide2(inputs)
	if (locale === "da") return da_components_mediaslider_nextslide2(inputs)
	if (locale === "de") return de_components_mediaslider_nextslide2(inputs)
	if (locale === "en-US") return en_us2_components_mediaslider_nextslide2(inputs)
	if (locale === "es-ES") return es_es2_components_mediaslider_nextslide2(inputs)
	if (locale === "es-MX") return es_mx2_components_mediaslider_nextslide2(inputs)
	if (locale === "fil") return fil_components_mediaslider_nextslide2(inputs)
	if (locale === "fr") return fr_components_mediaslider_nextslide2(inputs)
	if (locale === "it") return it_components_mediaslider_nextslide2(inputs)
	if (locale === "hu") return hu_components_mediaslider_nextslide2(inputs)
	if (locale === "nl") return nl_components_mediaslider_nextslide2(inputs)
	if (locale === "no") return no_components_mediaslider_nextslide2(inputs)
	if (locale === "pl") return pl_components_mediaslider_nextslide2(inputs)
	if (locale === "pt-BR") return pt_br2_components_mediaslider_nextslide2(inputs)
	if (locale === "pt") return pt_components_mediaslider_nextslide2(inputs)
	if (locale === "ro") return ro_components_mediaslider_nextslide2(inputs)
	if (locale === "fi") return fi_components_mediaslider_nextslide2(inputs)
	if (locale === "sv") return sv_components_mediaslider_nextslide2(inputs)
	if (locale === "vi") return vi_components_mediaslider_nextslide2(inputs)
	if (locale === "tr") return tr_components_mediaslider_nextslide2(inputs)
	if (locale === "cs") return cs_components_mediaslider_nextslide2(inputs)
	if (locale === "bg") return bg_components_mediaslider_nextslide2(inputs)
	if (locale === "ru") return ru_components_mediaslider_nextslide2(inputs)
	if (locale === "uk") return uk_components_mediaslider_nextslide2(inputs)
	if (locale === "ar") return ar_components_mediaslider_nextslide2(inputs)
	if (locale === "hi") return hi_components_mediaslider_nextslide2(inputs)
	if (locale === "th") return th_components_mediaslider_nextslide2(inputs)
	if (locale === "ja") return ja_components_mediaslider_nextslide2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_mediaslider_nextslide2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_mediaslider_nextslide2(inputs)
	return ko_components_mediaslider_nextslide2(inputs)
});
export { components_mediaslider_nextslide2 as "components.mediaSlider.nextSlide" }